import { Box, IconButton, makeStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { enqueueSnackbar, SNACKBAR_VARIANTS } from '../../redux_store';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';

const useStyles = makeStyles(theme => ({
  copyIcon: {
    width: 69,
    marginLeft: 15,
    [theme.breakpoints.down('sm')]: {
      width: 40,
      marginLeft: 8,
      padding: 8,
    },
  },
  link: {
    cursor: 'default',
    textAlign: 'center',
    display: 'flex',
    fontSize: 25,
    fontWeight: 500,
    padding: theme.spacing(2, 6),
    msUserSelect: 'none',
    userSelect: 'none',
    [theme.breakpoints.down('md')]: {
      fontSize: 18,
      padding: theme.spacing(1.5, 3),
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
      padding: theme.spacing(1, 2),
      wordBreak: 'break-all',
      lineHeight: 1.4,
    },
  },
  linkBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.colors.gray1,
    marginLeft: 84,
    [theme.breakpoints.down('md')]: {
      marginLeft: 40,
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      flex: 1,
      minWidth: 0, // Allow shrinking
    },
  },
  container: {
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0, 1),
    },
  },
}));

const CopyableLink = ({ link, onCopy }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(link);
      dispatch(
        enqueueSnackbar({
          message: 'Link copied to clipboard!',
          options: { variant: SNACKBAR_VARIANTS.SUCCESS },
        })
      );
      if (onCopy) {
        onCopy();
      }
    } catch (error) {
      console.error('Failed to copy link:', error);
      dispatch(
        enqueueSnackbar({
          message: 'Failed to copy link',
          options: { variant: SNACKBAR_VARIANTS.ERROR },
        })
      );
    }
  };

  return (
    <Box display="flex" justifyContent="center" className={classes.container}>
      <Box className={classes.linkBox}>
        <Typography className={classes.link}>{link}</Typography>
      </Box>
      <IconButton
        data-value={link}
        aria-label="copy"
        className={classes.copyIcon}
        size="medium"
        onClick={copyToClipboard}
      >
        <FileCopyOutlinedIcon fontSize="inherit" />
      </IconButton>
    </Box>
  );
};

CopyableLink.propTypes = {
  link: PropTypes.string.isRequired,
  onCopy: PropTypes.func,
};

export default CopyableLink;
